@if (showNavbar$()) {
  <sol-banner-host />
  <div class="sol-app-container">
    <div class="sol-app-navbar">
      <sol-navbar />
    </div>
    <div [class]="contentClass$()" data-shortcut-layer="content">
      <sol-details>
        <asm-topbar></asm-topbar>
        <sol-page>
          <sol-page-banner-host />
          @if (activeRouteStatus$() === 'loading') {
            <sol-layout p="16">
              <sol-loader [loader]="SolLoader.ofBlocks(3).withMargin('0')" />
            </sol-layout>
          } @else if (activeRouteStatus$() === 'forbidden') {
            <sol-error-page [type]="SolErrorPageType.FORBIDDEN" />
          } @else {
            <router-outlet />
          }
        </sol-page>
      </sol-details>
    </div>
  </div>
} @else if (isEmbed$()) {
  <sol-banner-host />
  <sol-details class="sol-app-content" data-shortcut-layer="content" [embedded]="true">
    <asm-topbar></asm-topbar>
    <sol-page>
      <sol-page-banner-host />
      @if (activeRouteStatus$() === 'loading') {
        <sol-layout p="16">
          <sol-loader [loader]="SolLoader.ofBlocks(3).withMargin('0')" />
        </sol-layout>
      } @else if (activeRouteStatus$() === 'forbidden') {
        <sol-error-page [type]="SolErrorPageType.FORBIDDEN" />
      } @else {
        <router-outlet />
      }
    </sol-page>
  </sol-details>
} @else {
  @if (activeRouteStatus$() === 'loading') {
    <sol-layout p="16">
      <sol-loader [loader]="SolLoader.ofBlocks(3)" />
    </sol-layout>
  } @else if (activeRouteStatus$() === 'forbidden') {
    <sol-error-page [type]="SolErrorPageType.FORBIDDEN" />
  } @else {
    <router-outlet />
  }
}
<sol-overlays />
<sol-debugger />
